import { DeleteOutlined, TagOutlined } from '@ant-design/icons';

export const massActionMenu = [
  {
    key: '1',
    Icon: TagOutlined,
    title: 'Добавить тег',
    dataTestId: 'add-tags',
  },
  {
    key: '2',
    Icon: DeleteOutlined,
    title: 'Удалить из базы',
    dataTestId: 'delete-from-database',
  },
];
